import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Services } from "@/components/Services";
import { About } from "@/components/About";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Contact } from "@/components/Contact";
import { Seo } from "@/components/Seo";

const Layout = ({ children, testid }) => (
  <div data-testid={testid} className="bg-[#0a0f1e] min-h-screen">
    <Navbar />
    <main className="pt-20">{children}</main>
    <Footer />
  </div>
);

export function ServicesPage() {
  return (
    <>
      <Seo
        title="Services — IT, Software, Hardware & Marketing | NetForge"
        description="Explore NetForge services: web & app development, custom CRM systems, cloud & IT solutions, IT hardware, digital marketing, SEO, branding and graphic design."
        path="/services"
      />
      <Layout testid="services-page">
        <Services />
      </Layout>
    </>
  );
}

export function AboutPage() {
  return (
    <>
      <Seo
        title="About Us — IT & Marketing Studio | NetForge"
        description="NetForge is an IT and marketing studio uniting senior engineers, designers and marketers to build the software, hardware and campaigns that scale modern businesses."
        path="/about"
      />
      <Layout testid="about-page">
        <About />
        <WhyChooseUs />
      </Layout>
    </>
  );
}

export function ContactPage() {
  return (
    <>
      <Seo
        title="Contact NetForge — Free Consultation | Build. Connect. Grow."
        description="Get in touch with NetForge for a free consultation on your IT, hardware, CRM or marketing project. We respond within 48 hours."
        path="/contact"
      />
      <Layout testid="contact-page">
        <Contact />
      </Layout>
    </>
  );
}
